import { IEvent } from '@/common/interfaces/events.interface';
import ZApiService from './ZApiService';

export default class UngerboeckService {
  private zApiService: ZApiService;

  public constructor(zApiService: ZApiService) {
    this.zApiService = zApiService;
  }

  public async getEvents(): Promise<IEvent[]> {
    return this.zApiService.getEvents();
  }
}
